import { useNavigate } from "react-router-dom";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import Sidebar from "../../components/Sidebar";

const BusinessCreateWaiverType = () => {
  const { business } = useBusinessAuthContext();
  const navigate = useNavigate();

  // 🔐 Auth guard (same pattern)
  if (!business) {
    navigate("/business/login");
    return null;
  }

  return (
    <div className="h-screen flex flex-row bg-background">
      {/* Left Sidebar */}
      <Sidebar />

      {/* Right Content */}
      <div className="flex-1 h-auto overflow-auto py-9 transition">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h1 className="text-3xl font-semibold mb-2">
            Create a Waiver
          </h1>

          <p className="text-foreground mb-10">
            Choose how you want to build your waiver
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
            {/* Smart Template */}
            <div className="bg-white rounded-xl shadow-sm p-8 relative">
              <span className="absolute top-6 right-6 bg-yellow-100 text-yellow-700 text-xs px-3 py-1 rounded-full">
                ⚡ Recommended
              </span>

              <h3 className="text-xl font-semibold mb-2">
                Smart Template
              </h3>

              <p className="text-foreground mb-6">
                Guided, pre-configured legal templates for common activities.
              </p>

              <ul className="space-y-2 text-sm mb-8">
                <li>✔ Standard legal structure</li>
                <li>✔ Activity-specific risk language</li>
                <li>✔ Protected core sections</li>
              </ul>

              <button
                onClick={() =>
                  navigate("/business/waiverbuilder/smart/step-1")
                }
                /*
                onClick={async () => {
                    const res = await api.post("/waivers/smart-template/draft");
                    navigate(`/business/waiverbuilder/smart/${res.data._id}`);
                }}
                */
                className="bg-highlited text-black font-medium py-3 px-6 rounded-full hover:bg-[#D5AA00] transition"
              >
                Create Smart Template →
              </button>
            </div>

            {/* Custom Waiver */}
            <div className="bg-white rounded-xl shadow-sm p-8">
              <h3 className="text-xl font-semibold mb-2">
                Custom Waiver
              </h3>

              <p className="text-foreground mb-6">
                Create your own waiver from scratch. You are responsible for the
                content and enforceability.
              </p>

              <ul className="space-y-2 text-sm mb-8">
                <li>✔ Full editing control</li>
                <li>✔ Custom legal language</li>
                <li>✔ User-defined structure</li>
              </ul>

              <button
                onClick={() =>
                  navigate("/business/waiverbuilder/custom", {
                    state: { from: "create-waiver" },
                  })
                }
                className="border border-gray-300 text-black font-medium py-3 px-6 rounded-full hover:bg-gray-100 transition"
              >
                Create Custom Waiver →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessCreateWaiverType;